import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e11e65e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "仅显示「对对碰」类型的目录", -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px","margin-top":"4px"}
}, "建议尺寸: 660 × 880 px (3:4 竖图)", -1))
const _hoisted_5 = { class: "ms-2 text-muted" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("单位：元")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("单位：积分")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("单位：军粮")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "新增赏品时的默认数量", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "每次游戏场上的牌数（建议9张）", -1))
const _hoisted_11 = { class: "ms-2 text-muted" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("草稿状态不会显示给用户")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("上线后用户可以游玩")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("下架后不再显示")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted ms-2",
  style: {"font-size":"12px"}
}, "开启后仅内部用户可见", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("保存基本信息")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_18 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("赏品配置")
const _hoisted_20 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("奖励配置")
const _hoisted_22 = {
  key: 2,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_ItemsManager = _resolveComponent("ItemsManager")!
  const _component_RewardsManager = _resolveComponent("RewardsManager")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.matchPool,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "池子名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.matchPool.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.matchPool.name) = $event)),
              placeholder: "请输入池子名称",
              maxlength: "100",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "所属目录",
          prop: "box_category_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.matchPool.box_category_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.matchPool.box_category_id) = $event)),
              placeholder: "请选择目录（可选）",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchCategories, (cat) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: cat.id,
                    label: cat.name,
                    value: cat.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "池子图片",
          prop: "image"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              class: "avatar-uploader",
              action: "",
              "auto-upload": false,
              "show-file-list": false,
              "on-change": _ctx.onImageChange
            }, {
              default: _withCtx(() => [
                (_ctx.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.imageUrl,
                      class: "avatar"
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      class: "avatar-uploader-icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["on-change"]),
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "描述",
          prop: "description"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.matchPool.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.matchPool.description) = $event)),
              type: "textarea",
              rows: 3,
              placeholder: "请输入池子描述",
              maxlength: "500",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "价格类型",
          prop: "box_type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.matchPool.box_type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.matchPool.box_type) = $event)),
              placeholder: "请选择价格类型"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "现金",
                  value: "cash"
                }),
                _createVNode(_component_el_option, {
                  label: "积分",
                  value: "membership_point"
                }),
                _createVNode(_component_el_option, {
                  label: "军粮",
                  value: "extra_point"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "单次价格",
          prop: "price"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.matchPool.price,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.matchPool.price) = $event)),
              min: 0,
              precision: 2,
              step: 1
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_5, [
              (_ctx.matchPool.box_type === 'cash')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_6
                  ], 64))
                : (_ctx.matchPool.box_type === 'membership_point')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_7
                    ], 64))
                  : (_ctx.matchPool.box_type === 'extra_point')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _hoisted_8
                      ], 64))
                    : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "默认牌数",
          prop: "default_quantity"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.matchPool.default_quantity,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.matchPool.default_quantity) = $event)),
              min: 1,
              max: 9999
            }, null, 8, ["modelValue"]),
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "场上牌数",
          prop: "field_size"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.matchPool.field_size,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.matchPool.field_size) = $event)),
              min: 3,
              max: 15
            }, null, 8, ["modelValue"]),
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "状态",
          prop: "status"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.matchPool.status,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.matchPool.status) = $event)),
              placeholder: "请选择状态"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "草稿",
                  value: "draft"
                }),
                _createVNode(_component_el_option, {
                  label: "上线",
                  value: "active"
                }),
                _createVNode(_component_el_option, {
                  label: "下架",
                  value: "archived"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_11, [
              (_ctx.matchPool.status === 'draft')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_12
                  ], 64))
                : (_ctx.matchPool.status === 'active')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_13
                    ], 64))
                  : (_ctx.matchPool.status === 'archived')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _hoisted_14
                      ], 64))
                    : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "仅内部测试" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.matchPool.is_test,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.matchPool.is_test) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_15
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    (!_ctx.isNew && _ctx.savedPoolId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_el_divider, { "content-position": "left" }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_ItemsManager, {
            "match-pool-id": _ctx.savedPoolId,
            "default-quantity": _ctx.matchPool.default_quantity,
            onUpdate: _ctx.onItemsUpdate
          }, null, 8, ["match-pool-id", "default-quantity", "onUpdate"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isNew && _ctx.savedPoolId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_el_divider, { "content-position": "left" }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_RewardsManager, {
            "match-pool-id": _ctx.savedPoolId,
            onUpdate: _ctx.onRewardsUpdate
          }, null, 8, ["match-pool-id", "onUpdate"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isNew)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createVNode(_component_el_alert, {
            title: "提示",
            type: "info",
            description: "请先保存基本信息，保存后可以配置赏品和奖励",
            closable: false
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}